import React from "react";
import { InputPropsWithoutRef } from "react-html-props";
import styled from "styled-components";

interface SearchInputProps extends InputPropsWithoutRef {
  spaceRight?: boolean;
}

const SearchInput = (props: SearchInputProps) => {
  return <TextInput type="search" {...props} />;
};

const TextInput = styled.input<{ spaceRight?: boolean }>`
  flex: 1;
  padding: 0.5rem 1rem;
  border-radius: 3px;
  border: 1px solid ${({ theme }) => theme.colors.gray700};
  margin-right: ${({ spaceRight }) => spaceRight && "1rem"};
`;

export default SearchInput;
